import {Component, inject, OnInit} from '@angular/core';
import { SideMenuComponent } from "./side-menu/side-menu.component";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { CommunitySvgSprite } from "./community-svg-sprite.component";
import { TranslateModule } from "@ngx-translate/core";
import {createInstructorPlanDialog} from '../admin/school-settings/change-instructor-plan-dialog/change-instructor-plan-dialog.component';
import {concatMap, tap, withLatestFrom} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {isAnyAdmin, isLoggedIn, selectTenantInfo, selectUser} from '../store/selectors';
import {MatDialog} from '@angular/material/dialog';
import {AppState} from '../store';
import {InstructorPlanService} from '../admin/school-settings/instructor-plan.service';
import {LoadingService} from '../shared/services/loading.service';
import {TenantService} from '../services/tenant.service';
import {instructorPlans} from '../admin/school-settings/instructor-plans';

import {combineLatest} from 'rxjs';
import {AllowRoleDirective} from '../shared/auth/allow-role.directive';
import {CommunityService} from './services/community.service';
import {updateSchoolDetails} from '../store/platform.actions';
import {TenantInfo} from '../models/tenant.model';
import {CommunitySettings} from '../models/community/community-settings.model';

declare const Stripe;

@Component({
  selector: "community",
  templateUrl: "./community.component.html",
  styleUrls: ["./community.component.scss"],
  standalone: true,
  imports: [
    SideMenuComponent,
    RouterOutlet,
    CommunitySvgSprite,
    TranslateModule,
    AllowRoleDirective,
  ],
})
export class CommunityComponent implements OnInit {

  dialog = inject(MatDialog);
  store = inject(Store<AppState>);
  instructorPlanService = inject(InstructorPlanService);
  loading = inject(LoadingService);
  tenantService = inject(TenantService);
  communityService = inject(CommunityService);

  totalRooms: number = 0;

  maxCommunityMembers: number = 0;

  totalActiveMembers: number = 0;

  isLoggedin: boolean = false;

  isAdmin: boolean = false;

  maxCommunityMembersInitialWarningEmailSent: boolean = false;

  maxCommunityMembersFinalWarningEmailSent: boolean = false;




  constructor(private route: ActivatedRoute) {

  }

  async ngOnInit() {

    combineLatest([
      this.store.pipe(select(selectUser)),
      this.store.pipe(select(isAnyAdmin)),
      this.store.pipe(select(isLoggedIn)),
      this.route.data,
      this.route.queryParamMap,

    ]).subscribe(([ user, isAdmin, isLoggedIn, data, queryParamMap]) => {

      this.totalRooms = data.rooms.length;
      this.isAdmin = isAdmin;
      this.isLoggedin = isLoggedIn;

    });

    const tenant = this.tenantService.tenant;
    this.maxCommunityMembers = instructorPlans[tenant.instructorPricingPlan]?.maxCommunityMembers ?? 0;
    this.totalActiveMembers = tenant?.communitySettings?.totalActiveMembers ?? 0;

  }

  onUpgrade() {
    createInstructorPlanDialog(this.dialog)
      .pipe(
        withLatestFrom(this.store.pipe(select(selectTenantInfo))),
        concatMap(([plan, tenant]) => this.loading.showLoaderUntilCompleted(
            this.instructorPlanService.updateInstructorPlan(
              false,
              tenant['email'],
              plan?.selectedInstructorPlanId,
              plan?.selectedPlanFrequency
            )
          )
        ),
        tap(response => {

          const stripe = Stripe(response.stripePublicKey);

          stripe.redirectToCheckout({
            sessionId: response.sessionId
          });

        })
      )
      .subscribe();
  }

  isCommunityMembersInfoVisible() {
    // a warning becomes visible to the tenant only when the community has reached at least 70% of its maximum capacity
    return this.totalActiveMembers >= 0.70 * this.maxCommunityMembers ;
  }

}
